import { rqClient } from "@/shared/api/instance";
import { useSession } from "@/shared/model/session";

export function useBalance() {
  const { isAuthenticated } = useSession();

  const { data, isPending, isError } = rqClient.useQuery(
    "get",
    "/api/v1/balance",
    {},
    {
      enabled: isAuthenticated,
      staleTime: 60 * 1000, // 1 minute
    },
  );

  return {
    balance: data,
    isPending,
    isError,
  };
}
